import { axiosInstance } from './axiosInstance';

export interface SyncResponse {
  success?: boolean;
  message?: string;
  [key: string]: unknown;
}

export async function syncMgsApi(): Promise<SyncResponse> {
  const response = await axiosInstance.post<SyncResponse>('/sync/mgs', undefined, { timeout: 300000 });
  return response.data;
}
